import * as React from "react";

const IconLook = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsVectornator="http://vectornator.io"
    xmlSpace="preserve"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit="10"
    clipRule="evenodd"
    viewBox="0 0 512 512"
  >
    <g vectornatorLayerName="Full">
      <path
        vectornatorLayerName="Curve 1"
        id="Full"
        fill="#ff5c97"
        d="M256 7.906C118.981 7.906 7.906 118.981 7.906 256S118.981 504.094 256 504.094 504.094 393.019 504.094 256 393.019 7.906 256 7.906m-49.375 86.782c61.823 0 111.937 50.114 111.937 111.937 0 27.995-10.357 53.529-27.343 73.156l7.843 7.875h21l90.532 90.532c8.946 8.945 8.946 23.46 0 32.406s-23.46 8.946-32.406 0l-90.532-90.532v-20.968l-7.875-7.875c-19.627 16.986-45.161 27.343-73.156 27.343-61.823 0-111.937-50.114-111.937-111.937S144.802 94.688 206.625 94.688m0 31.687c-44.324 0-80.25 35.926-80.25 80.25s35.926 80.25 80.25 80.25 80.25-35.926 80.25-80.25-35.926-80.25-80.25-80.25"
      ></path>
    </g>
  </svg>
);

export default IconLook;
